import { App } from "./app";

const stage = document.getElementById("stage")!;
const canvas = document.getElementById("game") as HTMLCanvasElement;
const ui = document.getElementById("ui")!;
const toasts = document.getElementById("toasts")!;

new App(stage, canvas, ui, toasts);
